
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core'

@Directive({
    selector: '[autofocusCustom]',
    standalone: false
})
export class AutoFocus implements AfterViewInit {
    @Input('autofocusCustom') enabledFocus: boolean = false;
    constructor(
        private readonly elementRef: ElementRef
    ) { }

    ngAfterViewInit() {
        if (this.enabledFocus) {
            setTimeout(() => {
                this.elementRef.nativeElement.focus();
            }, 0);
        }
    }
}